import type { Vendor } from '@shopgnd/shared';

export function isRealEstateVendor(vendor: Pick<Vendor, 'businessType' | 'businessModes'>): boolean {
  if ((vendor.businessType ?? '').toLowerCase() === 'real_estate') return true;
  return vendor.businessModes?.includes('listings') ?? false;
}

/** Admin-created real-estate vendors skip the property-agency approval queue. */
export function propertyListingApprovalForAdminProvision(
  vendor: Pick<Vendor, 'businessType' | 'businessModes'>,
): 'approved' | undefined {
  return isRealEstateVendor(vendor) ? 'approved' : undefined;
}
